import BaseNotification from '../BaseNotification'

export default class NewMessage extends BaseNotification {
  get processedMessage(): string {
    return super.processedMessage.replace(
      '{newMessageLink}',
      this.newMessageLink,
    )
  }

  get newMessageLink(): string {
    return `
        <router-link
          :to="{
            name: 'booking_messages',
            params: {id: ${this.notification.enquiryId}}
          }"
        >
          new message
        </router-link>
      `
  }

  get iconClass(): string {
    return 'sc-icon-message'
  }
}
